import {call, put, takeLatest} from "redux-saga/effects";
import {
  createOrganization,
  getOrganizationAppsAsync,
  getOrganizationAsync,
  getOrganizations,
  syncTemplateAsync,
} from "../AsyncActions/organization.async";
import * as actions from "../action.constants";
import {toast} from "react-toastify";
import {storeOrganization, storeOrganizationApps} from "../Actions/organizations.actions";

function* organizationsRequest(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getOrganizations, pageUrl);
    if (response) {
      yield put({
        type: actions.SAVE_ORGANIZATIONS_LIST,
        responsePayload: response?.data,
      });
    }
  } catch (e) {
    toast.error(e);
  }
}

function* createNewOrganization(action = {}) {
  const {requestPayload = {}, callback = () => {}} = action;
  try {
    const response = yield call(createOrganization, requestPayload);
    if (response) {
      yield callback();
    }
  } catch (e) {
    toast.error(e);
  }
}

function* syncTemplate(action = {}) {
  const {payload = {}} = action;
  try {
    yield call(syncTemplateAsync, payload);
  } catch (e) {
    toast.error(e);
  }
}

function* requestOrganization(action = {}) {
  const {payload = {}} = action;

  try {
    const response = yield call(getOrganizationAsync, {id: payload});
    if (response?.data) {
      yield put(storeOrganization(response?.data));
    }
  } catch (e) {
    toast.error(e);
  }
}

function* requestOrganizationApps(action = {}) {
  const {payload = {}} = action;

  try {
    const response = yield call(getOrganizationAppsAsync, {id: payload});
    if (response?.data) {
      yield put(storeOrganizationApps(response?.data?.results));
    }
  } catch (e) {
    toast.error(e);
  }
}

export function* orgSaga() {
  yield takeLatest(actions.REQUEST_ORGANIZATIONS, organizationsRequest);
  yield takeLatest(actions.CREATE_ORGANIZATION, createNewOrganization);
  yield takeLatest(actions.SYNC_TEMPLATES, syncTemplate);
  yield takeLatest(actions.REQUEST_ORGANIZATION, requestOrganization);
  yield takeLatest(actions.REQUEST_ORGANIZATIONS_APPS, requestOrganizationApps);
}
